import React from "react";
import styled from "styled-components/macro";
import BlackFridayBackground from "icons/BlackFridayBackground";
import SubscribedUntil from "./SubscribedUntil";

const BgWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 70%;
  overflow: hidden;
`;

const WhiteBg = styled.div`
  position: absolute;
  top: 77px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
`;

const ContentWrap = styled.div`
  position: relative;
  z-index: 1;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
`;

const BlackFridayTitle = styled.h2`
  font-size: 55px;
  font-family: "Noto Sans", "Segoe UI", sans-serif;
  color: transparent;
  font-weight: bold;
  -webkit-text-stroke: 2px white;
  margin: 0 0 15px;
  padding: 0 15px;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.2;
`;

const BlackFridaySubtitle = styled.h2`
  font-size: 55px;
  font-family: "Noto Sans", "Noto Sans", "Segoe UI", sans-serif;
  color: white;
  margin: 0 0 15px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 800;
  line-height: 1.2;
`;

type Props = {
  children: React.ReactNode;
};

const SubscriptionBlackFridayContent: React.FC<Props> = ({ children }) => {
  return (
    <>
      <Content>
        <BlackFridayTitle>Black Friday</BlackFridayTitle>
        <BlackFridaySubtitle>-60%</BlackFridaySubtitle>
        <SubscribedUntil />
      </Content>

      <BgWrap>
        <BlackFridayBackground />
      </BgWrap>
      <ContentWrap>
        <WhiteBg />
        <Content>{children}</Content>
      </ContentWrap>
    </>
  );
};

export default SubscriptionBlackFridayContent;
